// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueResource from 'vue-resource'
import router from './router'
import service from './service'
import './style/base.scss'
import './ui'
import filters from './util/filters'
import App from './view/App.vue'
Vue.config.productionTip = false
Vue.use(VueResource)
Vue.use(service)
Vue.use(filters)

let m = window.navigator.userAgent.match(/(android|ios)\/tv\.fuyin\/(.+?)$/)
if (m) {
  window.inApp = true
  window.app = m[1]
  window.appVersion = m[2]
}
window.isM = window.location.href.indexOf('mfuyin.tv/') >= 0

const parseQuery = function () {
  if (window.location.search) {
    return window.location.search.substr(1).split('&').map(q => q.split('=')).reduce((map, q) => {
      map[q[0]] = q[1]
      return map
    }, {})
  } else {
    return {}
  }
}

function next(err) {
  if (err) {
    console.error(err)
  }
  /* eslint-disable no-new */
  new Vue({
    el: '#app',
    router,
    template: '<App/>',
    components: { App }
  })
}

let params = parseQuery()
service.user.token = params.token
window.query = params
if (window.wx) {
  next()
  // service.wechat.sign(params).then(next).catch(next)
} else {
  next()
}




// WEBPACK FOOTER //
// ./src/main.js